import {h, resolveComponent} from 'vue'
import {createRouter, createWebHashHistory} from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'
import store from "@/store";
import {config} from "@/config";

const routes = [
    {
        path: '/',
        name: 'Inicio',
        component: DefaultLayout,
        redirect: '/panel',
        children: [
        
            {
                name: 'Panel',
                path: '/panel',
                component: () => import('@/views/windows/tareas/PanelProductos.vue'),
            },
            /*{
                name: 'Ver noticia',
                path: '/ver/noticia/:id?',
                component: () => import('@/views/windows/paginas/VerPost.vue'),
            },
            {
                name: 'Ver listado',
                path: '/ver/noticias',
                component: () => import('@/views/windows/paginas/VerListadoPublico.vue'),
            },
            {
                name: 'Ver ayuda',
                path: '/ver/ayuda-p/:id?',
                component: () => import('@/views/windows/paginas/VerPostAyuda.vue'),
            },
            {
                name: 'Ver listado ayuda',
                path: '/ver/ayuda',
                component: () => import('@/views/windows/paginas/VerListadoPublicoAyuda.vue'),
            }*/

        ],
    },
    {
        path: '/admin',
        name: 'Administración',
        component: DefaultLayout,
        redirect: '',
        children: [
            {
                name: 'Mi usuario',
                path: '/mi-usuario',
                component: () => import('@/views/windows/perfil/MiUsuario.vue'),
            },
            {
                name: 'Tareas',
                path: '/task-list',
                component: () => import('@/views/windows/tareas/ListadoTareas.vue'),

            },
            {
                name: 'Vista kanban',
                path: '/tareas/kanban',
                component: () => import('@/views/windows/tareas/TareasKanban.vue'),
            },
            {
                name: 'Tiempos de atención',
                path: '/tareas/tiempos-atencion',
                component: () => import('@/views/windows/tareas/TiemposAtencionDashboard.vue'),
            },
            {
                name: 'Flujo',
                path: '/flow/:tokenProducto/:tokenCotizacion',
                component: () => import('@/views/windows/tareas/CotizarProducto.vue'),
            },
            {
                name: 'Flujo (test)',
                path: '/testflow/:tokenProducto/:tokenCotizacion',
                component: () => import('@/views/windows/tareas/CotizarProducto.vue'),
            },
            {
                name: 'Flujos de trabajo',
                path: '/flow-editor',
                component: () => import('@/views/windows/flujos/Listado.vue'),
            },
            {
                name: 'Editar página',
                path: '/admin/blog/editar/:id?',
                component: () => import('@/views/windows/paginas/Editar.vue'),
            },
            {
                name: 'Listado de páginas',
                path: '/admin/blog/list',
                component: () => import('@/views/windows/paginas/Listado.vue'),
            },
            {
                name: 'Editar página de ayuda',
                path: '/admin/ayuda/editar/:id?',
                component: () => import('@/views/windows/paginas/EditarAyuda.vue'),
            },
            {
                name: 'Listado de páginas ayuda',
                path: '/admin/ayuda/list',
                component: () => import('@/views/windows/paginas/ListadoAyuda.vue'),
            },
            {
                name: 'Blog Listado',
                path: '/ver/noticias/listado',
                component: () => import('@/views/windows/paginas/Listado.vue'),
            },
            {
                name: 'Editar flujo',
                path: '/flow-editor/edit/:id',
                component: () => import('@/views/windows/flujos/Editar.vue'),
            },
            {
                name: 'Variables de sistema',
                path: '/admin/system-vars',
                component: () => import('@/views/windows/configuracion/VariablesSistema.vue'),
            },
            {
                name: 'Sistema',
                path: '/admin/sistema',
                component: () => import('@/views/windows/configuracion/Sistema.vue'),
            },
            /*Conexiones*/
            {
                name: 'Listado de conexiones',
                path: '/connections/list',
                component: () => import('@/views/windows/conexiones/Listado.vue'),
            },
            {
                name: 'Editar conexión',
                path: '/connections/edit/:id',
                component: () => import('@/views/windows/conexiones/Editar.vue'),
            },
            /* Alertas */
            {
                name: 'Listado de alertas',
                path: '/alerts/list',
                component: () => import('@/views/windows/alertas/Listado.vue'),
            },
            {
                name: 'Editar alerta',
                path: '/alerts/edit/:id',
                component: () => import('@/views/windows/alertas/Editar.vue'),
            },
            /* Administración de marcas (alta de clientes) */
            {
                name: 'Administrar marcas',
                path: '/admin/marcas',
                component: () => import('@/views/windows/marcas/MarcasAdmin.vue'),
            },
            /* Menús personalizados */
            {
                name: 'Listado de menús personalizados',
                path: '/admin/menus',
                component: () => import('@/views/windows/menus/Listado.vue'),
            },
            {
                name: 'Editar menú personalizado',
                path: '/admin/menus/edit/:id',
                component: () => import('@/views/windows/menus/Editar.vue'),
            },
        ],
    },
    {
        path: '/usuarios',
        name: 'Usuarios',
        component: DefaultLayout,
        redirect: '/usuarios/listado',
        children: [
            {
                name: 'Listado usuarios',
                path: '/usuarios/listado',
                component: () => import('@/views/windows/usuarios/UsuariosListado.vue'),
            },
            {
                name: 'Editar usuario',
                path: '/usuarios/edit/:id',
                component: () => import('@/views/windows/usuarios/UsuariosEditar.vue'),
            },
            {
                name: 'Metadata de usuarios',
                path: '/usuarios/metadata',
                component: () => import('@/views/windows/usuarios/UsuariosMetadata.vue'),
            },
            {
                name: 'Carga masiva de usuarios',
                path: '/usuarios/carga-masiva',
                component: () => import('@/views/windows/usuarios/UsuariosCargaMasiva.vue'),
            },
            {
                name: 'Listado roles',
                path: '/usuarios/roles/listado',
                component: () => import('@/views/windows/usuarios/RolesListado.vue'),
            },
            {
                name: 'Editar rol',
                path: '/usuarios/roles/edit/:id',
                component: () => import('@/views/windows/usuarios/RolesEditar.vue'),
            },
            {
                name: 'Canales de usuarios',
                path: '/usuarios/canal/listado',
                component: () => import('@/views/windows/usuarios/CanalUsuarioListado.vue'),
            },
            {
                name: 'Editar canal',
                path: '/usuarios/canal/edit/:id',
                component: () => import('@/views/windows/usuarios/CanalUsuarioEditar.vue'),
            },
            {
                name: 'Grupos de usuarios',
                path: '/usuarios/grupo/listado',
                component: () => import('@/views/windows/usuarios/GruposUsuarioListado.vue'),
            },
            {
                name: 'Editar grupo',
                path: '/usuarios/grupo/edit/:id',
                component: () => import('@/views/windows/usuarios/UsuariosGrupoEditar.vue'),
            },
            {
                name: 'Jerarquias de usuario',
                path: '/usuarios/jerarquia/listado',
                component: () => import('@/views/windows/usuarios/UsuarioJerarquiaListado.vue'),
            },
            {
                name: 'Jerarquias editar',
                path: '/usuarios/jerarquia/edit/:id',
                component: () => import('@/views/windows/usuarios/UsuarioJerarquiaEditar.vue'),
            },
        ],
    },
    {
        path: '/paneles',
        name: 'Paneles',
        component: DefaultLayout,
        redirect: '/paneles/listado',
        children: [
            {
                name: 'Configuración de paneles',
                path: '/paneles/config',
                component: () => import('@/views/windows/reportes/PanelesListado.vue'),
            },
            {
                name: 'Editar panel',
                path: '/paneles/configuracion/:id',
                component: () => import('@/views/windows/reportes/PanelesEditar.vue'),
            },
            {
                name: 'Listado de paneles',
                path: '/paneles/listado',
                component: () => import('@/views/windows/reportes/PanelesListadoMisPaneles.vue'),
            },
            {
                name: 'Ver panel',
                path: '/paneles/view/:id',
                component: () => import('@/views/windows/reportes/PanelesRender.vue'),
            },
        ],
    },
    {
        path: '/reportes',
        name: 'Reportes',
        component: DefaultLayout,
        redirect: '/reportes/configuracion',
        children: [
            {
                name: 'Configuración de reportes',
                path: '/reportes/configuracion',
                component: () => import('@/views/windows/reportes/Listado.vue'),
            },
            {
                name: 'Mis consumos',
                path: '/reportes/mis-consumos',
                component: () => import('@/views/windows/reportes/MisConsumos.vue'),
            },
            {
                name: 'Editar reporte',
                path: '/reportes/configuracion/:id',
                component: () => import('@/views/windows/reportes/Editar.vue'),
            },
            {
                name: 'Generar reporte',
                path: '/reportes/generar',
                component: () => import('@/views/windows/reportes/Generar.vue'),
            },
            {
                name: 'Descarga de documentos generados',
                path: '/reportes/download-docs',
                component: () => import('@/views/windows/reportes/DescargaDocs.vue'),
            },
            {
                name: 'Descarga masiva',
                path: '/reportes/descarga-masiva',
                component: () => import('@/views/windows/reportes/DescargaMasiva.vue'),
            },
        ],
    },
    {
        path: '/data',
        name: 'Datos',
        component: DefaultLayout,
        redirect: '/data/databases',
        children: [
            {
                name: 'Bases de datos',
                path: '/data/databases',
                component: () => import('@/views/windows/data/Listado.vue'),
            },
            {
                name: 'Edición de base',
                path: '/data/database/edit/:id',
                component: () => import('@/views/windows/data/Editar.vue'),
            },
            {
                name: 'Catálogos',
                path: '/data/catalog',
                component: () => import('@/views/windows/data/CatalogosListado.vue'),
            },
            {
                name: 'Edición de catálogo',
                path: '/data/catalog/edit/:id',
                component: () => import('@/views/windows/data/CatalogosEditar.vue'),
            },
            {
                name: 'Ver Datos',
                path: '/data/view',
                component: () => import('@/views/windows/data/VerDatosListado.vue'),
            },
            {
                name: 'Ver datos / Edición',
                path: '/data/view/:id',
                component: () => import('@/views/windows/data/EditarDatos.vue'),
            },
        ],
    },
    {
        path: '/reservas',
        name: 'Reservas',
        component: DefaultLayout,
        redirect: '/reservas/mis',
        children: [
            {
                name: 'Mis reservas',
                path: '/reservas/mis',
                component: () => import('@/views/windows/reservas/ReservasListado.vue'),
                props: { mode: 'mine' },
            },
            {
                name: 'Panel de agenda',
                path: '/reservas/panel',
                component: () => import('@/views/windows/reservas/ReservasListado.vue'),
                props: { mode: 'panel' },
            },
        ],
    },
    {
        path: '/configuration',
        name: 'Configuración',
        component: DefaultLayout,
        redirect: '/configuration/system',
        children: [
            {
                name: 'Configuración de sistema',
                path: '/configuration/sistema',
                component: () => import('@/views/windows/configuracion/NotificacionEditar.vue'),
            },
        ],
    },
    {
        path: '/menus',
        name: 'Menús personalizados',
        component: DefaultLayout,
        children: [
            {
                name: 'Vista de menú',
                path: '/menus/:menuId',
                component: () => import('@/views/windows/menus/Vista.vue'),
            },
        ],
    },
    {
        path: '/',
        redirect: '/404',
        component: {
            render() {
                return h(resolveComponent('router-view'))
            },
        },
        children: [
            {
                path: '/404',
                name: 'Page404',
                component: () => import('@/views/pages/Page404'),
                meta: {
                    public: true
                }
            },
            {
                path: '/f/:tokenProducto/:tokenCotizacion/:view?',
                name: 'Formulario',
                component: () => import('@/views/pages/Formularios.vue'),
                meta: {
                    public: true
                }
            },
            {
                path: '/testf/:tokenProducto/:tokenCotizacion/:view?',
                name: 'Formulario (test)',
                component: () => import('@/views/pages/Formularios.vue'),
                meta: {
                    public: true
                }
            },
            {
                path: '/track/:token',
                name: 'Seguimiento público',
                component: () => import('@/views/public/Tracking.vue'),
                meta: {
                    public: true
                }
            },
            {
                path: '/api-docs/:token',
                name: 'Documentación de API',
                component: () => import('@/views/public/ApiDocs.vue'),
                meta: {
                    public: true
                }
            },
            {
                path: '/login',
                name: 'Login',
                component: () => import('@/views/pages/Login.vue'),
                meta: {
                    public: true
                }
            },
            {
                path: '/blog/:slug',
                name: 'Blog',
                component: () => import('@/views/windows/paginas/VerPost.vue'),
                meta: {
                    public: true
                }
            },
            {
                path: '/ayuda/:slug',
                name: 'Ayuda',
                component: () => import('@/views/windows/paginas/VerPostAyuda.vue'),
                meta: {
                    public: true
                }
            },
            /*{
                path: '/reset-password',
                name: 'ResetPassword',
                component: () => import('@/views/pages/RecuperarPass.vue'),
                meta: {
                    public: true
                }
            },*/
            /*{
                path: '/reset-my-password/:token',
                name: 'ResetPasswordWToken',
                component: () => import('@/views/pages/RecuperarPass.vue'),
                meta: {
                    public: true
                }
            },
            {
                path: '/auth/manager',
                name: 'AuthManager',
                component: () => import('@/views/pages/AuthManager'),
                meta: {
                    public: true
                }
            }*/
            /*{
                path: '/register',
                name: 'Register',
                component: () => import('@/views/pages/Register'),
                meta: {
                    public: true
                }
            },
            ,*/
        ],
    },
]

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        // always scroll to top
        return {top: 0}
    },
})

router.beforeEach((to, from, next) => {
    const rutaPublica = to.matched.some(record => record.meta.public);

    /*console.log(to);
    console.log(rutaPublica);*/
    if (to.path === '/404' || to.path === '/login' || rutaPublica) {
        next();
    }
    else {
        store.dispatch('ValidateLogin', {
            callback: (response) => {

                if (typeof response.logged === 'undefined') {
                    next('/login');
                }
                else {
                    if (!rutaPublica) {
                        // valido si estoy logueado
                        //console.log(store.getters.authLogged);
                        if (store.getters.authLogged) {
                            next();
                        }
                        else {
                            window.location.href = '/#/login';
                            //next('login');
                        }
                    }
                    else {
                        next();
                    }
                }
            }
        });
    }

    /*console.log(rutaPublica);
    return false;*/
    //const isLoginClient = to.matched.some(record => record.meta.loginClient);


});

export default router
